import React from 'react';
import classNames from 'classnames';
import styles from './styles.scss';

const numberFormat = (value) =>
      new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: 'AUD'
      }).format(value);


const Money = ({ value, className, ...rest }) => {
    return (
        <span className={classNames(['money', className])}  {...rest}>
            {numberFormat(value)}
        </span>
    );
};

export default Money;
